import React, { useRef } from "react";
import { IoArrowUp } from "react-icons/io5";
import { Link } from "react-scroll";

function ScrollUp() {
  const container = useRef();
  function addScrollEffect() {
    // if (document.documentElement.scrollTop > 300) {
    //   container.current.classList.remove("scroller");
    // } else {
    //   container.current.classList.add("scroller");
    // }
    if (document.documentElement.scrollTop > 300) {
      container.current.classList.remove("shrink");
      container.current.classList.add("expand");
    } else {
      container.current.classList.remove("expand");
      container.current.classList.add("shrink");
    }
  }

  window.addEventListener("scroll", addScrollEffect);

  return (
    <div
      ref={container}
      className="shrink lg:hidden fixed bottom-24
   right-4 text-2xl  rounded-lg overflow-hidden cursor-pointer bg-gray-900 bg-opacity-90 text-white
   z-30"
    >
      <Link to="home" spy={true} smooth={true} offset={0} duration={500}>
        <div className="py-[15px] px-[10px]">
          <IoArrowUp />
        </div>
      </Link>
    </div>
  );
}

export default ScrollUp;
